import { z } from 'zod'

export const MAX_DAYS_RANGE = 30

export const invoiceSyncSchema = z.object({
    startDate: z.string().min(1, "Data inicial é obrigatória"),
    endDate: z.string().min(1, "Data final é obrigatória"),
}).refine((data) => {
    if (!data.startDate || !data.endDate) return true;
    const start = new Date(data.startDate);
    const end = new Date(data.endDate);
    const diffTime = Math.abs(end.getTime() - start.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays <= MAX_DAYS_RANGE;
}, {
    message: `O range máximo é de ${MAX_DAYS_RANGE} dias`,
    path: ["endDate"],
});

export type InvoiceSyncFormData = z.infer<typeof invoiceSyncSchema>;
